module.exports = __webpack_public_path__ + "img/violet_039.556b8884.png";